import Header from "@/components/header";
import LoadingPillItems from "@/components/loading/loadingPillItems/loadingPillItems";
import { useGetSmsPlaceHolder } from "@/services/smsPlaceHolders/hooks/useGetSmsPlaceHolder";
import { PlaceHolder } from "@/services/smsPlaceHolders/type";
import {
  Alert,
  Button,
  Group,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import {
  IconChevronLeft,
  IconChevronRight,
  IconInfoCircle,
} from "@tabler/icons-react";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type EditTemplate = {
  title: string;
  message: string;
};

function ExitTemplate() {
  const { state } = useLocation();
  const template = state?.template;
  const { data: placeHolders, isLoading: placeHolderLoading } =
    useGetSmsPlaceHolder();
  const navigate = useNavigate();
  const form = useForm<EditTemplate>({
    initialValues: {
      message: template?.text,
      title: template?.title,
    },
  });

  const replaceTagsWithValue = () => {
    const htmlContent = chatBoxRef.current?.innerHTML || "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    placeHolders?.forEach((tag) => {
      const tagElements = Array.from(
        tempDiv.getElementsByClassName("inserted-tag")
      );

      tagElements.forEach((element) => {
        // Check if the child span contains the label
        const childSpan = element.querySelector("span");
        if (
          childSpan &&
          childSpan.textContent?.replace("x", "") === tag?.value
        ) {
          const textNode = document.createTextNode(tag?.key || "");
          element.parentNode?.replaceChild(textNode, element);
          //element.textContent = tag.value; // Replace the entire tag element with its value
        }
      });
    });

    // Replace &nbsp; with a regular space
    return tempDiv.innerHTML.replace(/&nbsp;/g, " ");
  };

  const submit = (values: EditTemplate) => {
    const value = replaceTagsWithValue();
    // or .textContent, or .value for input/textarea

    navigate("/dashboard/messages/selectUser", {
      state: {
        template: {
          title: values?.title,
          message: value,
        },
      },
    });
  };

  const chatBoxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.innerHTML = template?.text;
    }
  }, []);

  const insertTagAtCaret = (tag: HTMLElement) => {
    chatBoxRef.current?.focus();
    const selection = window.getSelection();
    if (selection) {
      const range = selection.getRangeAt(0);
      range.deleteContents();
      const spanNode = document.createElement("span");
      spanNode.style.cssText =
        "background: #228be6 ; padding: 0 5px 0 0 ; color: white; border-radius: 5px;";
      spanNode.appendChild(tag);
      spanNode.setAttribute("contenteditable", "false");
      spanNode.classList.add("inserted-tag");
      range.insertNode(spanNode);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }
    chatBoxRef.current?.focus();
  };

  const addToDiv = (tag: PlaceHolder) => {
    const tagElement = document.createElement("span");
    tagElement.innerText = tag?.value || "";
    const removeButton = document.createElement("button");
    removeButton.innerText = "x";
    removeButton.onclick = () => removeTag(tagElement.parentElement);
    removeButton.ontouchstart = () => removeTag(tagElement.parentElement);
    removeButton.style.cssText = "background: none;border: none;color: white;";
    tagElement.appendChild(removeButton);
    insertTagAtCaret(tagElement);
  };

  const removeTag = (spanNode: HTMLElement | null) => {
    if (spanNode && spanNode.parentNode) {
      spanNode.parentNode.removeChild(spanNode);
    }
  };

  const theme = useMantineTheme();

  return (
    <Stack
      style={{
        display: "flex",
        height: "100svh",
      }}
    >
      <Header showHome showBack title="ویرایش قالب" />
      <Stack
        px="md"
        styles={{
          root: {
            flex: 1,
          },
        }}
      >
        <form id="editTemplate" onSubmit={form.onSubmit(submit)}>
          <Stack>
            <Group gap="5">
              <Text> قالب انتخابی </Text>
              <IconChevronLeft size={18} color={theme.colors.gray[6]} />
              <Text c="gray.7"> {template?.title}</Text>
            </Group>
            <Stack>
              <Alert color="yellow" icon={<IconInfoCircle />}>
                <Text size="xs">
                  با اضافه کردن آیتم های زیر به متن ، اطلاعات مشتریان هنگام
                  ارسال جایگزین خواهند شد
                </Text>
              </Alert>
              <Group id="tags" gap="xs">
                {placeHolderLoading ? (
                  <LoadingPillItems count={3} />
                ) : (
                  placeHolders?.map((tag, index) => (
                    <Button
                      type="button"
                      size="xs"
                      key={index}
                      onClick={() => addToDiv(tag)}
                    >
                      {tag?.value}
                    </Button>
                  ))
                )}
              </Group>
              <div
                id="chatbox"
                ref={chatBoxRef}
                contentEditable
                style={{
                  border: `1px solid ${theme.colors.gray[5]}`,
                  padding: "10px",
                  height: "300px",
                  borderRadius: "5px",
                }}
              ></div>
            </Stack>
          </Stack>
        </form>
      </Stack>
      <Stack px="md" mb="md">
        <Button type="submit" form="editTemplate" size="lg">
          <Group gap="xs">
            <IconChevronRight />
            <Text>انتخاب مشتریان </Text>
          </Group>
        </Button>
      </Stack>
    </Stack>
  );
}

export default ExitTemplate;
